import { healthClient } from '../services/health-client'

export const healthCheck = async () => {
  return healthClient().get(
      `${process.env.REACT_APP_HEALTH_CHECK_URL}`
  )
}
